import React from 'react';
import { Mail, Globe as GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { siteSettings } from '../utils/mockData';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-teal-900 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              {siteSettings.logo_url ? (
                <img 
                  src={siteSettings.logo_url} 
                  alt="Manalogi Logo" 
                  className="h-10 w-auto object-contain"
                />
              ) : (
                <>
                  <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-lg flex items-center justify-center">
                    <span className="text-white font-bold text-xl">M</span>
                  </div>
                  <span className="text-xl font-bold">{siteSettings.company_name || 'manalogi'}</span>
                </>
              )}
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              {t.footer.company}
            </p>
            <div className="space-y-2">
              <a
                href="mailto:halo@manalogi.com"
                className="flex items-center space-x-2 text-gray-300 hover:text-cyan-400 transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span>{t.contact.info.email}</span>
              </a>
              <a
                href="https://manalogi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-300 hover:text-cyan-400 transition-colors"
              >
                <GlobeIcon className="w-4 h-4" />
                <span>{t.contact.info.website}</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-cyan-400 transition-colors"
                >
                  {t.footer.links.about}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('solutions')}
                  className="text-gray-300 hover:text-cyan-400 transition-colors"
                >
                  {t.footer.links.solutions}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-gray-300 hover:text-cyan-400 transition-colors"
                >
                  {t.footer.links.products}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-cyan-400 transition-colors"
                >
                  {t.footer.links.contact}
                </button>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t.nav.solutions}</h3>
            <ul className="space-y-2">
              <li className="text-gray-300">Digital Tech Dev</li>
              <li className="text-gray-300">System Integra</li>
              <li className="text-gray-300">Consulting & Training</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-8 text-center text-gray-400">
          <p>
            © {currentYear} {t.footer.company}. {t.footer.rights}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
